import { mapProviderApi } from "@/core/apis";

// getter types
export const MAP_PROVIDERS = "mapProviders";

// action types
export const GET_MAP_PROVIDERS = "getMapProviders";
export const SAVE_MAP_PROVIDERS = "saveMapProviders";

// mutation types
const SET_MAP_PROVIDERS = "setMapProviders";
const SET_DEFAULT_MAP_PROVIDER = "setDefaultMapProvider";

const state = {
  mapProviders: []
};

const getters = {
  [MAP_PROVIDERS](state) {
    return state.mapProviders;
  }
};

const actions = {
  [GET_MAP_PROVIDERS](context) {
    return new Promise(resolve => {
      mapProviderApi.getList().then(response => {
        context.commit(SET_MAP_PROVIDERS, response.maps);

        resolve();
      });
    });
  },
  [SAVE_MAP_PROVIDERS](context, payload) {
    return new Promise(resolve => {
      mapProviderApi.saveDefault(payload).then(() => {
        context.commit(SET_DEFAULT_MAP_PROVIDER, payload);

        resolve();
      });
    });
  }
};

const mutations = {
  [SET_MAP_PROVIDERS](state, mapProviders) {
    state.mapProviders = mapProviders.map(c => ({
      id: c.id,
      name: c.name,
      url: c.urlTemplate,
      subdomains: c.subDomains,
      visible: false
    }));
  },
  [SET_DEFAULT_MAP_PROVIDER](state, id) {
    state.mapProviders.forEach(item => (item.visible = item.id === id));
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
